module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAOCAYAAAD0f5bSAAABVklEQVQoU52SrWuCYRTFfw/4hTYnfkW7/X0dgskoiov6B2wLWxAVjWIxbcK2KgiWDbTYBRm+VbBYjKJBg0EEhWe8PvgxtzB267nn3HPPvYJ/lDjnSE27RohHIIoQV0i5APpI+SQM4/PQuyfJWMzCZvNMMHhLNivQdXC7YbmEwQCaTcl0+obD8SB6vZ0iadoLmnZHtQpOJ6xWMJlAIAA+H6zXUC6DYbwKw7gXe0vBYJ9mU+wJwyGUShAKwXgMuRzE44qYzZoTo0Lq+jv5/A3JpLJcKEA4DJkMtFqmOtTrCut0oFb7MEkz2m3f3oZZpjW7HSwWJeDxQLGosPkcUqm5kJHIll7PgtX6PfxKBWYzUxlcLoVttxCL7X5OMsHFAhIJaLfB6z2JHSdd7nSw2O1COg0224l03OkyPbNlNFKpNRrg9yvSeXq/3unytS7v9O+POAj/9fe+ACOMqbvJUGmoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tip_icon.png
// module id = nqgp
// module chunks = 2